import { Typography } from 'antd';
import { useTexts } from '../hooks/useTexts';

const ForbiddenPage = () => {
    const { t } = useTexts();
    return <Typography.Text>{t('common', 'forbidden')}</Typography.Text>;
}
export default ForbiddenPage;